import { cn } from "cn";
import type * as React from "react";

// An empty list or page: icon tile, title, description and actions.
export function EmptyState({
  icon,
  title,
  description,
  children,
  className,
  testId,
}: {
  /** A lucide icon element, e.g. <ClipboardList />. */
  icon: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Actions (buttons), stacked on phones. */
  children?: React.ReactNode;
  className?: string;
  testId?: string;
}): React.JSX.Element {
  return (
    <section
      className={cn("mx-auto max-w-md py-12 text-center font-v3", className)}
      data-testid={testId}
    >
      <span
        aria-hidden
        className="mx-auto flex size-12 items-center justify-center rounded-2xl bg-v3-surface-2 text-v3-text-2 shadow-v3-hairline [&_svg]:size-6"
      >
        {icon}
      </span>
      <h2 className="mt-4 text-[17px] font-semibold leading-[22px] text-v3-text">
        {title}
      </h2>
      {description && (
        <p className="mt-1 text-[14px] leading-5 text-v3-text-3">
          {description}
        </p>
      )}
      {children && (
        <div className="mt-5 flex flex-col items-stretch justify-center gap-2 sm:flex-row sm:items-center">
          {children}
        </div>
      )}
    </section>
  );
}
